// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'

//VUEX 
import Vuex from 'vuex'
Vue.use(Vuex)
import { store } from '@/store/store.js';
//.VUEX 

//AXIOS
import axios from 'axios'
axios.defaults.baseURL = process.env.API_URL;

let token = window.localStorage.getItem('_token');
if (!!token) {
	axios.defaults.headers.common['authorization'] = `Bearer ${token}`;
}
//.AXIOS

//VEE-VALIDATE
import VeeValidate, { Validator } from 'vee-validate';
import validatorEs from '@/validator/es';
Validator.localize('es', validatorEs);
Vue.use(VeeValidate);
//.VEE-VALIDATE

Validator.extend('email', {
    validate: value => {

		let ok = false;

		ok = value.includes("@");
		if(ok){
			ok = value.includes(".")
		}

		if(ok){
			var regex = "\S*[\u00E0-\u00FC]\S*";
			let regexCompiled = new RegExp(regex);
			ok = !regexCompiled.test(value);
		}

		return ok;
    }
  });

import i18n from './i18n';


/*SENTRY*/
// import * as Sentry from '@sentry/browser';
// import { Vue as VueIntegration } from '@sentry/integrations';
// Sentry.init({
// 	dsn: 'https://9873ae9e28a3452bb7dbeb6e49316e52@o393426.ingest.sentry.io/5242501',
// 	integrations: [new VueIntegration({ Vue, attachProps: true, logError:true })],
// });


import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

// register globally
Vue.component('multiselect', Multiselect)


import dropzone from '@/components/parts/form/dropzone';
Vue.component('dropzone', dropzone)

import popupinfo from '@/components/parts/popup-info';
Vue.component('popup-info', popupinfo)

Vue.config.productionTip = false

new Vue({
	el: '#app',
	router,
	i18n,
	store,
	VeeValidate,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js